import React from 'react';

import { Input } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { InputProps } from 'components/ui/Input';
import useEnterSubmit from 'components/Login/hooks/useEnterSubmit';


type KioskLocationIdInputProps = {
  value?: number;
  canSubmit?: boolean;
  onSubmit?: () => void;
  wrapperClassName?: string;
} & Omit<InputProps, 'value'>;

const kioskLocationIdInputConfig: Partial<KioskLocationIdInputProps> = {
  center: true,
  type: 'number',
  role: 'textbox',
  spellCheck: false,
  autoCorrect: 'off',
  labelClassName: 'text-center',
  'data-testid': 'locationId-input',
  inputMode: 'numeric' as React.HTMLAttributes<HTMLInputElement>['inputMode'],
  label: <FormattedMessage id="login.locationId" defaultMessage="Location ID" />,
};

const KioskLocationIdInput: React.FC<KioskLocationIdInputProps> = ({
  value,
  error,
  onChange,
  onSubmit,
  canSubmit,
  wrapperClassName,
  ...rest
}) => {
  const handleKeyDown = useEnterSubmit(onSubmit, canSubmit);

  return (
    <div className={wrapperClassName}>
      <Input
        value={value}
        error={error}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        {...kioskLocationIdInputConfig}
        {...rest}
      />
      <p className="text-center italic text-sm text-default mt-3">
        <FormattedMessage
          id="login.locationIdHint"
          defaultMessage="Location ID is found on the sticker on the kiosk, 3 or 4 digits."
        />
      </p>
    </div>);
};

export default KioskLocationIdInput;